var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4.154 6.628V6.48h.692c.128 0 .23-.107.23-.24a.235.235 0 0 0-.23-.24h-.692v-.48h.692c.128 0 .23-.108.23-.24a.235.235 0 0 0-.23-.24h-.692v-.48h.692c.128 0 .23-.108.23-.24a.235.235 0 0 0-.23-.24h-.692V3.6h.692c.128 0 .23-.108.23-.24a.235.235 0 0 0-.23-.24h-.692v-.48h.692c.128 0 .23-.108.23-.24a.235.235 0 0 0-.23-.24h-.692V1.2C4.154.47 3.61 0 2.769 0c-.84 0-1.384.47-1.384 1.2v5.428A2.89 2.89 0 0 0 0 9.12C0 10.708 1.242 12 2.77 12c1.526 0 2.768-1.292 2.768-2.88a2.89 2.89 0 0 0-1.384-2.492zM2.769.48c.278 0 .923.07.923.72v.96H1.846V1.2c0-.65.646-.72.923-.72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureFilled);
export default __webpack_public_path__ + "static/media/temperature-filled.8fe5b772216a930239d857d8d7b08acc.svg";
export { ForwardRef as ReactComponent };